module.exports = __webpack_public_path__ + "img/recommend-btn.1ae649bc.png";